import React, { useState } from 'react';
import { useSession } from '../../../Components/Session';
import Modal from '../../../Components/Modal';
import Form, { Actions, Address, PhoneNumber, PhoneNumberValidator, RequiredValidator, TextField } from '../../../Components/Form';
import { useUser } from '../../../Data/Users';
import { useBusiness } from '../../../Data/Business';
import Alert from '../../../Components/Alert';
import Button from '../../../Components/Button/Button';

const InitialSetup = () => {
    const {user, business, refresh} = useSession();

    if (user && !user.firstName) {
        return <UserNameRequired refresh={refresh} />
    }

    if (business && !business?.address?.postcode) {
        return <BusinessAddressRequiredRequired refresh={refresh} />
    }

    return null;
}

const UserNameRequired = ({refresh}) => {
    const {user, update} = useUser();

    return <Modal title="Welcome to getSoapy" isOpen={true} setIsOpen={() => null}>
        <Form data={user} onSubmit={update} afterSubmit={refresh} closeModalOnSubmit waitForData>
            <p className="text-muted">
                To get started, please tell us your name?
            </p>
            <TextField name="firstName" label="First name" validators={[RequiredValidator]} />
            <TextField name="lastName" label="Surname" validators={[RequiredValidator]} />
            <Actions submit={{label: 'Save'}} />
        </Form>
    </Modal>
}

const BusinessAddressRequiredRequired = ({refresh}) => {
    const {business, saveDetails} = useBusiness();
    const [isOpen, setIsOpen] = useState(true);

    if (!isOpen) {
        return <Alert
            icon="Info"
            title="Complete your business details"
            message="To enable some features including nearby leads and route optimisations, we need to know where you're based."
            buttons={[
                <Button theme="primary" label="Complete details" onClick={() => setIsOpen(true)} />
            ]}
        />
    }

    return <Modal title="Business details" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        <Form data={business} onSubmit={saveDetails} afterSubmit={refresh} closeModalOnSubmit waitForData>
            <p className="text-muted">
                To enable some features including nearby leads and route optimisations, we need to know where you're based.
            </p>
            <TextField name="name" label="Business Name" validators={[RequiredValidator]} />
            <Address name="address" label="Address" validators={[RequiredValidator]} />
            <PhoneNumber name="phoneNumber" label="Phone number" validators={[PhoneNumberValidator]} />
            <Actions submit={{label: 'Save'}} cancel={{label: 'Later'}} />
        </Form>
    </Modal>
}

export default InitialSetup;
